import React from 'react';
import { Card, Transition } from 'semantic-ui-react';

import { Progress } from 'src/components/coreUI';
import Base from 'src/components/coreUI/Card/Base';
import { getExpiredDate } from 'src/utils/helper';

type Props = {
  progress?: number;
  onClick?: () => void;
  class_user: Model.ClassUser;
};

export default class UserCourse extends Base<Props> {
  render() {
    const { onClick, progress, class_user } = this.props;

    const { expired_date, dateLeft } = getExpiredDate(class_user);

    return (
      <Transition animation="fade down" transitionOnMount duration={500}>
        <Card fluid onClick={onClick}>
          {this.renderBase()}
          <Card.Content extra>
            <Progress
              percent={progress}
              type="rectangular"
              renderLabel={(per) => (
                <div className="text-primary mb-4">{`${per}% progress`}</div>
              )}
            />
            <div className="d-flex justify-between fs-16">
              <Card.Meta>valid until {expired_date}</Card.Meta>
              {dateLeft <= 0 ? (
                <Card.Meta textAlign="right">Expired</Card.Meta>
              ) : (
                <Card.Meta textAlign="right">{dateLeft} days left</Card.Meta>
              )}
            </div>
          </Card.Content>
        </Card>
      </Transition>
    );
  }
}
